import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { dgInput, required, email, dgSelect } from 'dg-forms';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var User_Form = /*#__PURE__*/function (_Component) {
  _inherits(User_Form, _Component);

  var _super = _createSuper(User_Form);

  function User_Form() {
    _classCallCheck(this, User_Form);

    return _super.apply(this, arguments);
  }

  _createClass(User_Form, [{
    key: "render",
    value: function render() {
      var _this$props$editingEx;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          type = _this$props.type,
          setPage = _this$props.setPage;
      return /*#__PURE__*/React.createElement("form", {
        className: "form-container",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "fields-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "first_name",
        type: "text",
        component: dgInput,
        label: "First Name",
        placeholder: "First Name",
        labelClass: "required",
        validate: [required]
      }), /*#__PURE__*/React.createElement(Field, {
        name: "last_name",
        type: "text",
        component: dgInput,
        label: "Last Name",
        placeholder: "Last Name",
        labelClass: "required",
        validate: [required]
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email",
        type: "email",
        component: dgInput,
        placeholder: "Email",
        label: "Email",
        labelClass: "required",
        validate: [required, email]
      })), type === 'Admin' ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        labelClass: "required",
        label: "Administrator",
        name: "isAdmin",
        component: dgSelect
      }, /*#__PURE__*/React.createElement("option", {
        "default": true,
        value: "false"
      }, "False"), /*#__PURE__*/React.createElement("option", {
        value: "true"
      }, "True"))) : '', /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "password",
        type: "password",
        component: dgInput,
        label: "Password",
        labelClass: (_this$props$editingEx = this.props.editingExistingUser) !== null && _this$props$editingEx !== void 0 ? _this$props$editingEx : 'required',
        validate: this.props.editingExistingUser ? [] : [required]
      }))), /*#__PURE__*/React.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn-primary",
        type: "submit",
        disabled: submitting
      }, "Save")), type !== 'Admin' ? /*#__PURE__*/React.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/React.createElement("button", {
        onClick: function onClick() {
          setPage(1);
        },
        className: "btn-primary alt",
        type: "button",
        disabled: submitting
      }, "Back")) : '');
    }
  }]);

  return User_Form;
}(Component);

User_Form = reduxForm({
  form: 'User_Form'
})(User_Form);
var UserForm = User_Form;

export { UserForm as U };
